export const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

export const getInvoiceSubtotal = (items) => roundMoney(items.reduce((sum, item) => (
  sum + roundMoney(Math.max(Number(item.Price) * Number(item.qty) - Number(item.lineDiscount || 0), 0))
), 0));

export const getInvoiceDiscountError = (value, subtotal) => {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount < 0) return 'Enter a valid, non-negative discount.';
  if (Math.abs(amount - roundMoney(amount)) > 0.0000001) return 'Use at most two decimal places.';
  if (amount > subtotal) return 'Invoice discount cannot exceed the subtotal.';
  return '';
};
